<template>
<div class="chapter">
<div class="inner_page">
<h1>Acknowledgments</h1>
<p class="sectiontop">A lot of generous people lent their time and expertise to the story that ultimately became <i>Lucky Stars,</i> and they all deserve mention along with my very sincere thanks and gratitude:</p>
<p>Jennifer Enderlin, my enthusiastic editor, who pored over several drafts of the book and offered insightful and constructive comments after each reading;</p>
<p>Ellen Levine, my literary agent, who continues to both guide my career with her customary competence and laugh out loud at my jokes;</p>
<p>The five talented actresses who shared their experiences with me and gave the heroine of this book authenticity and guts—Elisabeth Blake, Donna Lynn Leavy, Dawn Maxie, Shannon Morris, and Cindy Warden;</p>
<p>Julia Grossman, Howard Papush, Adryan Russ, and Steven Shmerler, who helped me gain access to some of the above women;</p>
<p>Ed Kreins, captain of the Beverly Hills Police Department, and Michael Barrett, former detective of the Westport Police Department, who are wise in the ways of catching criminals;</p>
<p>Laurence Caso, Mort Lowenstein, Tim Mason, and Brad Schreiber, who made suggestions that gave the story credibility and/or just plain made it better;</p>
<p>Helen Gallagher, Patty Bunch, and Maurice Stein, makeup artists extraordinaire, whose contributions were invaluable as I prepared my heroine for her “big scene”;</p>
<p>Laurie Burrows Grad, who either knows everything or knows how to find out everything, and is a fabulous cook on top of it;</p>
<p>Kristen Powers, my Web guru, who allows me to communicate with my readers on <a href="http://www.janeheller.com" target="_blank">www.janeheller.com</a>;</p>
<p>Michael Forester, my husband, who, when I whined, “I’ll <i>never</i> be able to come up with another idea for a book,” rolled his eyes and replied, “You always say that.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?5d2e4bde